import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'prism-title',
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent {
  @Input() title?: string;
  @Input() additionalClasses?: string = 'text-3xl';
  @Input() headingLevel: 'h1' | 'h2' | 'h3' | 'h4' = 'h1';

  @HostBinding('attr.title')
  get titleAttr(): null { return null; }
}
